
import { Component, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class Survey extends Vue {
    public statusMessage = '';

    public async announce(message: string): Promise<void> {
        this.statusMessage = '';
        await this.$nextTick();
        this.statusMessage = message;
    }
}
